import { FC } from 'react';
import ArrowRight from 'images/arrow-right.svg';

const ArrowRightIcon: FC = () => {
  return <img src={ArrowRight} alt="arrow-right-icon" />;
};
export default ArrowRightIcon;
